<template>
    <div
        class="Header"
        :class="{ 'Header--desktop': !isMobile }"
    >
        <nav class="Header-navigation">
            <transition
                name="header-navigation"
                mode="out-in">
                <template v-if="$route.path !== '/'">
                    <span
                        class="Header-backButton-container"
                        key="hempel-icon">
                        <hempel-icon
                            class="Header-arrow"
                            name="arrowLeft"/>
                        <span
                            class="Header-back"
                            @click="dataLayerAdd({
                                type: 'calculatorEvent',
                                category: 'Paint Calculator',
                                action: 'Misc',
                                label: 'Click on Back'
                            })"
                            @click.prevent="$router.back()">{{ back }}</span>
                    </span>
                </template>
                <template v-if="$route.path === '/'">
                    <hempel-input-language key="hempel-input-lang"/>
                </template>
            </transition>
            <hempel-logo
                @click.native="dataLayerAdd({
                    type: 'calculatorEvent',
                    category: 'Paint Calculator',
                    action: 'Misc',
                    label: 'Click on Hempel Logo'
                })"
            />
        </nav>
    </div>
</template>
<script>
import HempelLogo from '@/components/shared/logo/Logo'
import HempelIcon from '@/components/shared/icon/Icon'
import HempelInputLanguage from '@/components/shared/input/InputLanguage'

export default {
    name: 'HempelHeader',
    components: {
        HempelLogo,
        HempelIcon,
        HempelInputLanguage
    },
    computed: {
        back() {
            return this.translation.navigation
        }
    }
}
</script>
